<template>
  <div v-if="demandeImpression" class="columns is-multiline mgt-0">
    <div class="border-entete column is-12">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('detailDemandeImpression.title') }}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <dropdownButton
              class="mgr-2"
              type="is-addOrEdit"
              :permission="constantes.DEMANDE_IMPRESSION.maj"
              :actions="actionSecondaire"
              @click="() => {
                $router.push({
                  name: 'm.logistique.demande_impression-edit',
                  params: { id: demandeImpression.id }
                })
              }">
                {{ $t('listeDemandeImpression.actions.editDemandeImpression')}}
            </dropdownButton>
            <qd-button
              v-if="demandeImpression.graphisteEnChargeId !== user.id"
              :class="[
                {'button-access-no-permission': !checkPermissionsMaj},
                {'pointer-events-none': !checkPermissionsMaj},
              ]"
              @click="applyUpdateGraphistesEnCharge()"
              class="button is-addOrEdit">
              {{ $t('detailDemandeImpression.actions.updateGraphiste')}}
            </qd-button>
            <piece-jointe-button
              class="mgr-2"
              :perm="constantes.DEMANDE_IMPRESSION.maj"
              autoSave>
            </piece-jointe-button>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-10 pdl-0">
      <div class="mgt-20px">
        <error-msg-component
          v-if="showErrorMsgComponent"
          :messages="messages"
          :messagesChampsVide="messagesChampsVide"
          :champsVide="champsVide"
          :error="error"
          :title="'general.problemOccurred'"
          :withEmplyFields="true"
          @close="error = $event"/>
      </div>
      <app-avertissement-msg-component
        v-if="informations.length !== 0"
            :title="'detailDemandeImpression.alerteCommentaireHead'"
            :avertissement="true"
            :messages="informations"
            :canClose="true"
    ></app-avertissement-msg-component>
      <user-warning-message
        :users="[{
          id: demandeImpression.demandeurId,
          msg: 'utilisateur.warning.demandeurArchive'
        }]"/>
      <informations-generales :demandeImpression="demandeImpression">
      </informations-generales>
      <info-dispositif class="mgt-20px"
        :demandeImpression="demandeImpression">
      </info-dispositif>
      <info-campagne class="mgt-20px"
        v-if="moduleCampagneActive"
        :demandeImpression="demandeImpression">
      </info-campagne>
      <info-commentaire class="mgt-20px"
        :title="$t('detailDemandeImpression.infoGenerale.description')"
        :texte="demandeImpression.description">
      </info-commentaire>
      <info-commentaire class="mgt-20px"
        :title="$t('detailDemandeImpression.infoGenerale.commentaire')"
        :texte="demandeImpression.commentaire">
      </info-commentaire>
      <div class="card mgt-20px">
        <header class="header-card">
          <p>
            {{ $t('piecesJointes.attachments')}}
          </p>
        </header>
        <div class="card-content">
          <app-pieces-jointes readOnly
            deletable
            autoSave
            :checkPermissions="checkPermissions(constantes.DEMANDE_IMPRESSION.maj)"/>
        </div>
      </div>
    </div>
    <div class="column is-2 pdt-0">
      <information-create-update-user :data="demandeImpression" class="mgr-20px">
      </information-create-update-user>
    </div>
    <b-modal
      v-model="popUpPrevention"
      @close="closePopUpPrevention()"
      class="modal"
      has-modal-card>
      <pop-up-prevention
        :messHeader="$t('detailDemandeImpression.popup.graphiste.title')"
        :messDescription="$t('detailDemandeImpression.popup.graphiste.desc')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :champsVide="champsVide"
        :messagesPopup="messages"
        :isErrorPopup.sync="error"
        :messagesChampsVide="messagesChampsVide"
        @no="popUpPrevention = false"
        @yes="actionSetGraphistesEnCharge()">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import { DEMANDE_IMPRESSION } from '@/configuration/logistique/permissionsLogistiqueConf';
import {
  get, createOTs,
  updateGraphisteDemandeImpressionAll,
  updateCampagneDemandeImpressionAll,
} from '@/api/logistique/demandeImpression/index';
import messageErreur from '@/services/general/messageErreur';
import messageSuccess from '@/services/general/messageSucces';
import dropdownButton from '@/components/general/button/dropdownButton';
import userWarningMessage from '@/components/commun/user/userWarningMessage';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { SET_CAMPAGNE } from '@/store/modules/logistique/demandeImpression-mutation-type';
import informationsGenerales from '@/components/logistique/demandeImpression/detail/informationsGenerales';
import infoDispositif from '@/components/logistique/demandeImpression/detail/infoDispositif';
import infoCampagne from '@/components/logistique/demandeImpression/detail/infoCampagne';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import translate from '@/services/logistique/ordreTravail/tech/validation/translate';
import translateDemandeImpression from '@/services/logistique/demandeImpression/translateDemandeImpression';
import validationOTTech from '@/services/logistique/ordreTravail/tech/validation/validation';
import validationDemandeImpression from '@/services/logistique/demandeImpression/validationDemandeImpression';
import validationGeneral from '@/services/validation/validation';
import infoCommentaire from '@/components/logistique/demandeImpression/detail/infoCommentaire';
import PopUpPrevention from '@/components/general/popUpPrevention';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import PiecesJointes from '@/components/general/piecesJointes';
import InformationCreateUpdateUser from '@/components/general/informationCreateUpdateUser';
import AppAvertissementMsgComponent from '@/components/general/avertissementMsgComponent';

const User = createNamespacedHelpers('user');
const Permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');
const Attachments = createNamespacedHelpers('attachments');
const DemandeImpression = createNamespacedHelpers('demandeImpression');

export default {
  data() {
    return {
      demandeImpression: null,
      informations: [],
      constantes: {
        DEMANDE_IMPRESSION,
      },
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      popUpPrevention: false,
      loadingComponent: null,
    };
  },
  components: {
    breadcrumb,
    userWarningMessage,
    informationsGenerales,
    infoDispositif,
    infoCampagne,
    infoCommentaire,
    pieceJointeButton,
    appPiecesJointes: PiecesJointes,
    dropdownButton,
    errorMsgComponent,
    PopUpPrevention,
    InformationCreateUpdateUser,
    AppAvertissementMsgComponent,
  },
  computed: {
    ...User.mapGetters({
      user: 'user',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...DemandeImpression.mapGetters({
      campagneStore: 'campagne',
    }),
    checkPermissionsMaj() {
      return this.checkPermissions(DEMANDE_IMPRESSION.maj);
    },
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeDemandeImpression.breadcrumb.listeDemandeImpression'), route: { name: 'l.logistique.demande_impression' }, isActive: false },
        { title: this.$t('detailDemandeImpression.breadcrumb.detail'), route: '', isActive: true },
      ];
    },
    moduleCampagneActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.campagne.key);
    },
    actionSecondaire() {
      const actions = [];
      if (this.demandeImpression.devisCommandes?.length === 0) {
        actions.push({
          label: this.$t('listeDemandeImpression.actions.creerOT'),
          action: this.createOT,
        });
      }
      return actions;
    },
    showErrorMsgComponent() {
      return !this.popUpPrevention && this.error;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    ...DemandeImpression.mapMutations({
      setCampagne: SET_CAMPAGNE,
    }),
    setInformations() {
      const informations = [];
      if (this.demandeImpression.commentaire) {
        informations.push({
          isLink: false,
          message: this.$i18n.t('detailDemandeImpression.alerteCommentaire'),
        });
      }
      this.informations = informations;
    },
    async createOT() {
      this.resetFieldsErrorMsg();
      const loadingComponent = this.$buefy.loading.open();
      try {
        const OTids = (await createOTs([this.$route.params.id])).data.result;
        if (OTids.length > 0) {
          this.$router.push({
            name: 'c.logistique.ordre_travail-tech',
            params: { id: OTids[0] },
          });
        }
      } catch (e) {
        if (e.response && e.response.data.error) {
          validationOTTech(e.response, this.messages);
          validationDemandeImpression(e.response, this.messages);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
          throw e;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    async getDemandeImpressionAsync() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await get(this.$route.params.id);
        this.demandeImpression = response.data.result;
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    resetFieldsErrorMsg() {
      this.error = false;
      this.messages = [];
      this.champsVide = [];
      this.messagesChampsVide = [];
    },
    closePopUpPrevention() {
      this.resetFieldsErrorMsg();
      this.popUpPrevention = false;
    },
    applyUpdateGraphistesEnCharge() {
      if (!this.checkPermissionsMaj) {
        this.showPopUp();
        return;
      }
      this.resetFieldsErrorMsg();
      this.popUpPrevention = true;
    },
    async actionSetGraphistesEnCharge() {
      this.debutLoading();
      try {
        await updateGraphisteDemandeImpressionAll({
          ids: [this.$route.params.id],
          graphisteEnChargeId: this.user.id,
        });
        messageSuccess(this.$t('detailDemandeImpression.messages.graphisteChangeSuccess'));
        this.popUpPrevention = false;
        await this.getDemandeImpressionAsync();
      } catch (e) {
        if (e.response?.data?.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translateDemandeImpression);
          this.error = true;
          throw e;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.finLoading();
      }
    },
    async actionSetCampagne() {
      if (!this.campagneStore) return;
      this.debutLoading();
      try {
        await updateCampagneDemandeImpressionAll({
          ids: [this.$route.params.id],
          campagneId: this.campagneStore.id,
        });
        this.setCampagne(null);
        messageSuccess(this.$t('detailDemandeImpression.messages.campagneChangeSuccess'));
      } catch (e) {
        if (e.response?.data?.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translateDemandeImpression);
          this.error = true;
          throw e;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.finLoading();
      }
    },
  },
  async mounted() {
    this.debutLoading();
    try {
      await this.actionSetCampagne();
      await this.setAttachmentContext({ module: 'DemandeImpression' });
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.campagne.key]);
      await this.getDemandeImpressionAsync();
      await this.setAttachmentElementId({ id: this.$route.params.id });
      this.setInformationPage(this.$t('pageDemandeImpression.detail'));
      this.setInformations();
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      this.finLoading();
    }
  },
};

</script>
